module.exports = __webpack_public_path__ + "img/ico-check-white.25809d41.svg";